import * as actionTypes from '../constants/actionTypes';

export default(state = {}, action) => {
    switch (action.type) {
        case actionTypes.SERVICE_LIST_JOBS:
            return {
                ...state,
                jobs: action.payload
            };
        case actionTypes.SERVICE_LIST_LOGS:
            return {
                ...state,
                logs: action.payload
            };
        case actionTypes.SERVICE_CLEAR_LOGS:
            return {
                ...state,
                logs: null
            };
        default:
            return state;
    }
};